import { $, $$, setAttributes } from 'utils/dom';
import { uniqueId } from 'utils/helper';
import Datepicker from '../../macros/datepicker/datepicker';

const Filter = $('.filter');

if (Filter) {
  const datepicker = $('.filter__datepicker');
  if (datepicker) {
    const datepickerInput = $('.datepicker__input', datepicker);
    const fullDate = date =>
      `${date.getFullYear()}${date.getMonth() + 1 < 10 ? '0' : ''}${
        date.getMonth() + 1
      }${date.getDate() < 10 ? '0' : ''}${date.getDate()}`;
    const getFormattedDate = (startdate, enddate) => {
      const formattedStartDate = fullDate(startdate);
      const formattedEndDate = enddate
        ? fullDate(enddate)
        : fullDate(startdate);
      const valueTemplate = datepickerInput.dataset.value;

      return enddate
        ? valueTemplate
            .replace('___FROM___', `${formattedStartDate}0000`)
            .replace('___TO___', `${formattedEndDate}2359`)
        : valueTemplate
            .replace('___FROM___', `${formattedStartDate}0000`)
            .replace('___TO___', '');
    };
    const datePicker = new Datepicker({
      inputNode: $('.datepicker__input', datepicker),
      dialogNode: $('.datepicker__dialog', datepicker),
      disablePastDates: false,
      disablePastMonths: true,
      firstDayOfWeek: 'mon',
      onDaySet: date => {
        const dateValue = getFormattedDate(date);

        datepickerInput.value = dateValue; // update input value
        // TODO: trigger ajax
      },
    });
    datePicker.init();
  }
}

export const initFilterToggle = calendarForm => {
  const randomID = uniqueId();
  const target = $('.filter__panel', calendarForm);
  const handler = $('.filter__button', calendarForm);

  setAttributes(handler, {
    id: `acc-btn-${randomID}`,
    'aria-controls': `acc-tab-${randomID}`,
  });

  setAttributes(target, {
    id: `acc-tab-${randomID}`,
    'aria-labelledby': `acc-btn-${randomID}`,
  });

  handler.addEventListener('click', () => {
    const status = handler.getAttribute('aria-expanded');

    if (status === 'false') {
      handler.setAttribute('aria-expanded', 'true');
      target.setAttribute('aria-hidden', 'false');
    } else {
      handler.setAttribute('aria-expanded', 'false');
      target.setAttribute('aria-hidden', 'true');
    }
  });
};
const calendarForms = $$('.filter');
if (calendarForms.length) {
  calendarForms.forEach(calendarForm => {
    initFilterToggle(calendarForm);
  });
}
